import React, { useState } from 'react';
import AttachmentsSection from '@app/pages/attachment/AttachmentsSection.tsx';
import { UploadedAttachment } from '@components/ringil3/Features/Attachments/UploadAttachmentDialog.tsx';

interface ComponentProps {}

const MapComponent: React.FC<ComponentProps> = () => {
  const [attachments, setAttachments] = useState<UploadedAttachment[]>([]);

  return (
    <>
      <AttachmentsSection attachments={attachments} onChange={setAttachments} />
    </>
  );
};

export default MapComponent;
